import { bg_image_template_10 } from "../templates/Template10/constant";

export const MEDIA_TYPE = {
    IMAGE: "img_view",
    VIDEO: "video_view",
};

export const TESTIMONIAL_TYPE = {
    TEXT: "text_view",
    IMAGE: "img_view",
    VIDEO: "video_view",
};

export const DEFAULT_SOURCES = {
    VIDEO: "",
};

export const TESTIMONIAL_DISPLAY_TYPE = {
    LIST: "vertical_list",
    CAROUSEL: "horizontal_carousel",
} as const;

export const REQUIREMENT_DEFAULT_VALUE = {
    DEFAULT: "requirement",
    CUSTOM: "benefit",
};

export const FEATUREDIN_DEFAULT_VALUE = {
    DEFAULT: "Media House",
    CUSTOM: "Benefit",
};

export const TEMPLATE_SLUGS = {
    template1: "template1",
    template2: "template2",
    template3: "template3",
    template4: "template4",
    template5: "template5",
    template6: "template6",
    template7: "template7",
    template9: "template9",
    template10: "template10",
    template11: "template11",
};

type ISsrScreenSizeDefaults = {
    mobile: "mobile";
    desktop: "desktop";
};

export const ssr_screen_size_defaults: ISsrScreenSizeDefaults = {
    mobile: "mobile",
    desktop: "desktop",
};

export const ADD_VIDEO_OPTIONS = {
    ADD_LINK: { slug: "add_link", label: "Via link" },
    UPLOAD_VIDEO: { slug: "upload_video", label: "Upload video" },
    ADD_EMBED_CODE: { slug: "add_embed_code", label: "Embed code" },
};

export const titleValue: {
    [key: string]: {
        [key: string]: string;
    };
} = {
    [TEMPLATE_SLUGS.template10]: {
        title: REQUIREMENT_DEFAULT_VALUE.CUSTOM,
    },
};

export const customImage: {
    [key: string]: {
        [key: string]: string;
    };
} = {
    [TEMPLATE_SLUGS.template10]: {
        customBgImage: bg_image_template_10,
    },
};

export const featured_in_preview_title: {
    [key: string]: {
        [key: string]: string;
    };
} = {
    [TEMPLATE_SLUGS.template10]: {
        customTitle: FEATUREDIN_DEFAULT_VALUE.CUSTOM,
    },
};
